import { render, staticRenderFns } from "./VendorRequestDetailsReceiver.vue?vue&type=template&id=7b4852e1"
import script from "./VendorRequestDetailsReceiver.vue?vue&type=script&lang=js"
export * from "./VendorRequestDetailsReceiver.vue?vue&type=script&lang=js"
import style0 from "./VendorRequestDetailsReceiver.vue?vue&type=style&index=0&id=7b4852e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports